<template>
    <div class="mt-3 mb-3">
        <BButton variant="outline-primary" v-on:click="chooseContragents">Додати</BButton>
    </div>
    
    <div class="users_in row">
        <div class="col-md-4 col-xs-12 col-lg-4" v-for="user in subscribes">
            <div class="card" :key="'in_' + user.user_id" >
                <div  class="card-header">
                    <div class="user_info">
                        <div class="cursor-pointer" @click="showUser(user)">
                            {{user.company}}
                        </div>
                        <div class="color-danger-50" v-if="user.subscription_deactivated == 1">
                            Відключена розсилка
                        </div>
                    </div>
                    <span class="rem_user_ins btn btn-icon btn-sm btn-danger shadow waves-effect waves-themed cursor-pointer"
                          @click="dellUser(user)">
                        <i class="fal fa-times"></i>
                    </span>
                
                </div>
                
                <div class="card-body">
                    <div>{{user.contact_name}}</div>
                    <div>{{user.contact_tel}}</div>
                </div>
                
                <div class="card-footer">
                    <small class="text-muted">Останнє відвідування {{user.lastvisitDate}}</small>
                </div>
            </div>
        </div>
    </div>
    
    <usersel
        @users_selected="this.pushUsers"
        id = "users-modal"
        name_ = ' учасників'
        :users="subscribes">
    </usersel>
    
</template>

<script>
import {
    BButton,
    BTab
} from 'bootstrap-vue-next';
import usersel from "../contragents/usersel.vue";
import Protocol_add_user from "../../../protocol/inside/add_user/protocol_add_user.vue";

export default {
    name: "tender_users_in",
    emits : ['changeAtr'],
    
    components : {
        Protocol_add_user,
        usersel,
        BButton
    },
    
    props : {
        tender : {
            type : Object
        }
    },
    
    data() {
        return {
            is_load: false,
        }
    },
    
    methods : {
        pushUsers(event) {
              this.subscribes = event?.users || [];
        },
        
        chooseContragents() {
            EventBus.$emit('choose_contragents');
        },
        
        showUser(user) {
            window.location.href = "/kontrahenty/" + user.user_id;
        },
        
        dellUser(user) {
            this.subscribes = this.subscribes.filter(u => u.user_id !== user.user_id)
        }
    },
    
    computed : {
        
        subscribes : {
            
            get() {
                return this.tender.subscribes_in;
            },
            
            set(val) {
                console.log('new_subscribes',val);
                this.$emit('changeAtr', {
                    field: 'subscribes_in',
                    value: this.subscribes
                })
                this.tender.subscribes_in = val;
            }
        },
        
        is_first() {
            return this.tender.type === 'first_simple';
        },
    }
}
</script>


<style scoped>

</style>